/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo, useCallback } from 'react';
import { useWatch } from 'react-hook-form';
import EpQuestionCheckbox from '../EpQuestionCheckbox';
import EpQuestionDate from '../EpQuestionDate';
import EpQuestionNumber from '../EpQuestionNumber';
import EpQuestionRadio from '../EpQuestionRadio';
import EpQuestionSelect from '../EpQuestionSelect';
import EpQuestionText from '../EpQuestionText';

type QuestionsAnswersProps = {
  id: number;
  inputValue: string | string[] | null;
  questionId: number;
  questionDescription: string;
  required: boolean;
  maxLength: number;
  questionReferLibraryId: number;
  questionTypeId: number;
  questionsLibrary: boolean;
  questionCategoryIncident: number;
  order: number;
  answerRequiredId: number | null;
  questionRequiredId: number | null;
  answers: {
    answerId: number;
    answerDescription: string;
  }[];
};

const EpWrapperQuestion = ({
  QuestionsAnswers,
  index,
  translations,
}: {
  QuestionsAnswers: QuestionsAnswersProps;
  index: any;
  translations?: string[];
}) => {
  const ShowQuestion = useCallback(
    function ShowQuestionCallback() {
      const questions = useWatch({ name: `questions` });
      let show = true;
      if (QuestionsAnswers.questionRequiredId) {
        show = false;
        questions.map((question: QuestionsAnswersProps) => {
          if (show) return;
          if (
            question.questionId === QuestionsAnswers.questionRequiredId &&
            Number(question.inputValue) === QuestionsAnswers.answerRequiredId
          ) {
            show = true;
          }
        });
      }
      return show;
    },
    [QuestionsAnswers.questionRequiredId, QuestionsAnswers.answerRequiredId],
  );

  if (!ShowQuestion()) {
    return null;
  }

  if (QuestionsAnswers.questionTypeId === 1) {
    return (
      <EpQuestionText
        translations={translations}
        QuestionsAnswers={QuestionsAnswers}
        index={index}
        key={QuestionsAnswers.id}
      ></EpQuestionText>
    );
  }

  if (QuestionsAnswers.questionTypeId === 2) {
    return (
      <EpQuestionDate
        QuestionsAnswers={QuestionsAnswers}
        index={index}
        key={QuestionsAnswers.id}
      ></EpQuestionDate>
    );
  }

  if (QuestionsAnswers.questionTypeId === 3) {
    return (
      <EpQuestionSelect
        QuestionsAnswers={QuestionsAnswers}
        index={index}
        key={QuestionsAnswers.id}
      ></EpQuestionSelect>
    );
  }

  if (QuestionsAnswers.questionTypeId === 4) {
    return (
      <EpQuestionRadio
        QuestionsAnswers={QuestionsAnswers}
        index={index}
        key={QuestionsAnswers.id}
      ></EpQuestionRadio>
    );
  }

  if (QuestionsAnswers.questionTypeId === 5) {
    return (
      <EpQuestionCheckbox
        QuestionsAnswers={QuestionsAnswers}
        index={index}
        key={QuestionsAnswers.id}
      ></EpQuestionCheckbox>
    );
  }

  if (QuestionsAnswers.questionTypeId === 6) {
    return (
      <EpQuestionNumber
        translations={translations}
        QuestionsAnswers={QuestionsAnswers}
        index={index}
        key={QuestionsAnswers.id}
      ></EpQuestionNumber>
    );
  }

  return null;
};

export default memo(EpWrapperQuestion);
